import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Spinner } from 'react-bootstrap';
import Filters from './Filters';
import { downloadFile } from '../../../services/utils';
import { indexApiPayrollRequest } from '../../../requests/payrollProcesses';
import { sendAlert } from '../../../actions/utils';

const ProcessReportsIndex = () => {
  const dispatch = useDispatch();
  const [report, setReport] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const { currentCompany } = useSelector(state => state.auth);

  const handleRequestProcess = params => {
    setIsLoading(true);
    indexApiPayrollRequest({
      dispatch,
      params: {
        ...params,
        filter_by_company: currentCompany.id
      },
      successCallback: ({ data }) => {
        if (!data?.data?.length) {
          dispatch(
            sendAlert({ kind: 'error', message: 'No existen procesos de remuneracion en las fechas proporcionadas' })
          );
        }
      },
      callback: () => {
        setIsLoading(false);
      }
    });
  };

  const handleRequest = (params, request) => {
    setIsLoading(true);
    if (!request) {
      handleRequestProcess(params);
      return;
    }
    request({
      dispatch,
      params: {
        ...params,
        filter_by_company: currentCompany.id,
        sort_year_month_options: 'desc'
      },
      format: params.format,
      successCallback: response => {
        downloadFile(response);
      },
      callback: () => {
        setIsLoading(false);
      }
    });
  };

  return (
    <>
      <Filters report={report} isLoading={isLoading} setReport={setReport} formRequest={handleRequest} />
      <div className="position-relative">
        {isLoading && (
          <div className="containerSpinnerLoad position-absolute h-100 w-100">
            <Spinner animation="border" variant="primary" />
          </div>
        )}
      </div>
    </>
  );
};

export default ProcessReportsIndex;
